import { LibConfig } from "../../init";
export const updateAllRegions = (regions) => {
    regions.forEach(region => {
        LibConfig.allRegions.set(region.id, region);
    });
};
//# sourceMappingURL=updateAllRegions.js.map